.root {
  cursor: var(--cursor-ds-interactive);
}
